import React from 'react';
import Services from '../Services/Services';

const HomeAboutService = () => {
    return (
        <div>
           <Services></Services>
        </div>
    );
};

export default HomeAboutService;